import toast from "react-hot-toast";

export const toogleSuccessMessage = (payload) => (dispatch) => {
  toast.success(payload);
};

export const toogleErrorMessage = (payload) => (dispatch) => {
  toast.error(payload);
};
